import { useSelector } from "react-redux";
import { useMemo } from "react";
import config from "../config";

const useSchool = () => {

  const { schools } = useSelector((state) => state.schoolDetails);
  console.log(schools);

  // ✅ normalize school
  const school = useMemo(() => {
    if (!schools) return null;

    if (Array.isArray(schools)) {
      return schools.length > 0 ? schools[0] : null;
    }

    return schools;
  }, [schools]);

  // ✅ logo comes from API endpoint
  const logoUrl = `${config.apiBaseUrl}/logo/getLogo.php`;

  return {
    school,
    logoUrl
  };
};

export default useSchool;